import { AdminTableTypeEnum } from "src/requests/administration/types";
import { action, fsa } from "ts-action";
import {
  DELETE_OVERVIEW_TABLES_FILTER,
  SET_LOADING_OVERVIEW_TABLES,
  SET_OVERVIEW_TABLES,
  SET_OVERVIEW_TABLES_FILTER,
} from "./actionTypes";
import { OverviewTablesByTemplateId } from "./types";

export const setOverviewTablesAction = action(
  SET_OVERVIEW_TABLES,
  fsa<{ tablesByTemplateId: OverviewTablesByTemplateId }>()
);

export const setOverviewTablesLoading = action(
  SET_LOADING_OVERVIEW_TABLES,
  fsa<{ isLoading: boolean }>()
);

export const setOverviewTablesFilter = action(
  SET_OVERVIEW_TABLES_FILTER,
  fsa<{
    tablesByTemplateId: unknown;
    templateId: number | AdminTableTypeEnum;
  }>()
);

export const deleteOverviewTablesFilter = action(
  DELETE_OVERVIEW_TABLES_FILTER,
  fsa<{ templateId: number | AdminTableTypeEnum }>()
);
